import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { T4coreModule, UIService } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { SendMessageDialog } from './dialogs/SendMessageDialog/SendMessageDialog';
import { InboxComponent } from './views/inbox/inbox.component';
import { NotificationsComponent } from './views/notifications/notifications.component';



@NgModule({
    declarations: [
        InboxComponent,
        NotificationsComponent,
        SendMessageDialog
    ],
    imports: [
        T4CommonModule,
        T4coreModule,
        RouterModule.forChild([
            {
                path: 'Messages',
                data: {
                    hidden: true,
                    index: 1000, title: "Messages", toolTip: "You internal communication platform", icon: "mail", color: 'accent'
                },
                children: [
                    { path: '', redirectTo: 'Notifications', pathMatch: 'full' },
                    {
                        path: "Notifications",
                        component: NotificationsComponent,
                        data: { title: "Notifications", toolTip: "Important information", icon: "notification_important", color: 'accent' }
                    },
                    {
                        path: "Inbox",
                        component: InboxComponent,
                        data: { title: "Inbox", toolTip: "Inbox", icon: "inbox", color: 'accent' }
                    }
                ]
            },
        ])
    ],
    providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }]
})
export class MessagingModule { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({ dialogs: [{ key: "T4.Messaging.SendMessage", dialog: SendMessageDialog }] });
  };
}
// Module initialization
